import React, { useCallback, useState } from 'react'
import BasicCalendar from '../../common/basic-calendar'
import moment from 'moment'

const TestScreen = () => {
    const [ dateSelected, setDateSelected ] = useState(moment())
    const getDateColor = useCallback(date => {
        switch (date) {
        case '2021-01-03': return BasicCalendar.Colors.PRIMARY
        case '2021-01-07': return BasicCalendar.Colors.PRIMARY
        case '2021-01-09': return BasicCalendar.Colors.ALERT
        }
    }, [])
    return (
        <React.Fragment>
            <BasicCalendar
                dateSelected={dateSelected}
                onDateSelectChange={setDateSelected}
                getDateColor={getDateColor}
            />
        </React.Fragment>
    )
}

export default TestScreen